import { reactive } from 'vue';

// A single NavConfirmDialog instance, mounted once by AppChrome: every chrome action that used to
// rely on a legacy VM method to raise its own swal (clear cart, cancel a visit, clear the cache...)
// now decides for itself whether to ask first, and calls the legacy business module directly on
// confirm - never the VM method that would have shown the legacy dialog.
const state = reactive({ open: false, title: '', lines: [], icon: 'help', confirmText: 'Yes', cancelText: 'No', inputLabel: null, run: null, cancel: null });

export const useConfirmAction = () => state;

/**
 * @param {object} options
 * @param {string} options.title
 * @param {string[]} [options.lines]
 * @param {string} [options.icon]
 * @param {string} [options.confirmText]
 * @param {string} [options.cancelText]
 * @param {string|null} [options.inputLabel]  shows a text field, run(value) receives its content
 * @param {(value?: string) => void} options.run
 * @param {() => void} [options.cancel]  called when the cancel button is clicked
 */
export function confirmAction({ title, lines = [], icon = 'help', confirmText = 'Yes', cancelText = 'No', inputLabel = null, run, cancel = null }) {
	Object.assign(state, { open: true, title, lines, icon, confirmText, cancelText, inputLabel, run, cancel });
}

export function closeConfirmAction() {
	state.open = false;
	state.run = null;
	state.cancel = null;
}
